<template><div><h1>路由</h1>
<p>推荐直接使用官方 <a href="https://github.com/vuejs/vue-router">vue-router</a>，<code>VUX</code>部分组件支持<code>link</code>属性直接支持<code>vue-router</code>的路由参数，<code>vux2</code>模板内置了<code>vue-router</code>。</p>
<div class="warning">
<p><del>如果使用了过渡(转场动画)，在<code>iPhone</code>上使用<code>左划返回</code>时动画会再执行一遍，目前没有找到可行的处理方法，如果你有处理方案，欢迎<code>PR</code>。</del><br>
<a href="https://github.com/airyland/vux/pull/2259">https://github.com/airyland/vux/pull/2259</a></p>
</div>
</div></template><script>
export default {
  head: {"title":"vue-router 路由 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// router-153.vue?5b5014d4